export default __webpack_public_path__ + "static/media/bg4.64ac2718.jpg";